/* Gallo PDP - centre-stone shape as swatches, not a dropdown.

   On the old site the shape is picked from a row of round swatches, each drawn
   with the outline of the stone and named underneath. The new PDP rendered the
   same option as a plain select, which reads as an afterthought sitting under
   the metal swatches.

   This upgrades that one control in place. The select stays in the form and
   remains the source of truth: the variant resolver and the gallery filter both
   read it, so neither had to change, and if this script never runs the page
   still works exactly as it did, just with a dropdown.

   The drawings are Gallo's own - the same shape files the old site uses, copied
   into this theme as assets/gallo-shape-<name>.svg rather than referenced
   across themes, so nothing breaks when the old theme is retired. The old site
   only has sprite cells for five shapes, so Emerald and Princess cut render as
   blank gaps there; here every shape in the catalogue has its drawing.

   The URL for each drawing comes from Liquid, in window.GALLO_SHAPE_ICONS. A
   shape with no drawing keeps its name and simply shows an empty ring, which is
   the honest outcome and never a broken image.

   These are loaded eagerly on purpose. They are a few kilobytes each and they
   are part of the control itself, not page decoration; left lazy they sit
   permanently unloaded inside a small element and the row comes up empty. */
(function () {
  'use strict';

  var SHAPES = ['round', 'oval', 'pear', 'marquise', 'emerald', 'princess', 'radiant',
                'cushion', 'asscher', 'heart', 'trillion', 'baguette'];

  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim(); }

  function shapeKey(text) {
    var t = norm(text);
    for (var i = 0; i < SHAPES.length; i += 1) { if (t.indexOf(SHAPES[i]) !== -1) return SHAPES[i]; }
    return null;
  }

  function iconFor(key) {
    var map = window.GALLO_SHAPE_ICONS || {};
    var src = key ? map[key] : null;
    if (!src) return null;
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.width = 60;
    img.height = 60;
    img.setAttribute('aria-hidden', 'true');
    return img;
  }

  /* The shape control is whichever select in the product form offers shape
     names. Ring size, and the concierge widget sitting on the same page, are
     left alone. */
  function shapeSelect(form) {
    var selects = form.querySelectorAll('select');
    for (var i = 0; i < selects.length; i += 1) {
      var s = selects[i], hits = 0;
      for (var j = 0; j < s.options.length; j += 1) { if (shapeKey(s.options[j].value)) hits += 1; }
      if (s.options.length > 1 && hits >= Math.ceil(s.options.length / 2)) return s;
    }
    return null;
  }

  function build(select) {
    var row = document.createElement('div');
    row.className = 'shape-swatches';
    row.setAttribute('data-shape-group', '');

    var buttons = [];
    var legendValue = null;

    function paint() {
      for (var i = 0; i < buttons.length; i += 1) {
        var on = buttons[i].getAttribute('data-opt-value') === select.value;
        if (on) { buttons[i].classList.add('selected'); } else { buttons[i].classList.remove('selected'); }
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      if (legendValue) legendValue.textContent = select.value;
    }

    for (var i = 0; i < select.options.length; i += 1) {
      (function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'shape-swatch';
        b.setAttribute('data-opt-value', opt.value);
        b.title = opt.value;

        var ring = document.createElement('span');
        ring.className = 'shape-ico';
        var img = iconFor(shapeKey(opt.value));
        if (img) ring.appendChild(img);

        var name = document.createElement('span');
        name.className = 'shape-label';
        name.textContent = (opt.textContent || opt.value).trim();

        b.appendChild(ring);
        b.appendChild(name);
        b.addEventListener('click', function () {
          if (select.value === opt.value) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          paint();
        });

        row.appendChild(b);
        buttons.push(b);
      })(select.options[i]);
    }

    var fs = select.closest ? select.closest('fieldset') : null;
    if (fs) {
      var legend = fs.querySelector('legend');
      if (legend) {
        legendValue = document.createElement('span');
        legendValue.className = 'field-value';
        legend.appendChild(legendValue);
      }
    }

    select.parentNode.insertBefore(row, select);
    select.classList.add('shape-select-hidden');
    select.setAttribute('tabindex', '-1');
    select.addEventListener('change', paint);
    paint();
  }

  function init() {
    var form = document.getElementById('pdp-form');
    if (!form) return;
    var select = shapeSelect(form);
    if (!select || select.getAttribute('data-shape-upgraded')) return;
    select.setAttribute('data-shape-upgraded', '1');
    try { build(select); } catch (e) { select.classList.remove('shape-select-hidden'); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
